<template>
<div class="chapter">
<div class="inner_page">
<p class="fhead">Contents</p>
<p class="toc"><a href="#/ack">Acknowledgements</a></p>
<p class="toc"><a href="#/intro">Introduction</a></p>
<p class="toc1"><a href="#/chapter1">1. In the Beginning</a></p>
<p class="toc"><span href="#/chapter2" title="Link target outside of Sample">2. Bentham’s Restaurant, Sweet’s Hotel, the Pantlind Hotel and the Amway Grand Plaza</span></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample">3. Fine Dining</span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample">4. Casual but Still Fine</span></p>
<p class="toc"><span href="#/chapter5" title="Link target outside of Sample">5. A Pinch of This and a Dash of That</span></p>
<p class="toc"><span href="#/chapter6" title="Link target outside of Sample">6. Diners and Drive-Ins</span></p>
<p class="toc"><span href="#/chapter7" title="Link target outside of Sample">7. Historic Treasures Still Going Strong</span></p>
<p class="toc1"><span href="#/app" title="Link target outside of Sample">Appendix: Recipes</span></p>
<p class="toc"><span href="#/bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?bab6cefa